import React from "react";
import { PageHeader } from "@/components/Common";
import { WrenchIcon, ClockCountdownIcon } from "@phosphor-icons/react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

/**
 * Placeholder for features that are being reworked on the backend.
 * Used for /dispatch and /fuel until they are re-enabled.
 */
export default function ComingSoon({ title = "Coming soon", eyebrow = "Under construction" }) {
  return (
    <div data-testid="coming-soon-page">
      <PageHeader eyebrow={eyebrow} title={title} subtitle="This section is being reworked. Check back soon." />
      <div className="p-8">
        <div className="max-w-2xl mx-auto bg-white border border-slate-300 rounded-sm p-10 text-center">
          <div className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-amber-50 border border-amber-200 mb-4">
            <WrenchIcon size={28} weight="fill" className="text-amber-700" />
          </div>
          <div className="text-[10px] uppercase font-mono text-amber-700 font-bold mb-1 flex items-center justify-center gap-1">
            <ClockCountdownIcon size={12} weight="bold" /> In progress
          </div>
          <div className="font-display text-2xl font-black tracking-tight text-slate-900 mb-2">
            {title}
          </div>
          <p className="text-sm text-slate-600 max-w-md mx-auto mb-6">
            We&apos;re rebuilding this feature to make it faster and more reliable. It will be back shortly with new capabilities. Thanks for your patience.
          </p>
          <div className="flex items-center justify-center gap-3">
            <Link to="/app">
              <Button className="bg-slate-900 hover:bg-slate-800 rounded-sm" data-testid="cs-back-dashboard">
                Back to Dashboard
              </Button>
            </Link>
            <Link to="/repairs">
              <Button variant="outline" className="rounded-sm" data-testid="cs-go-repairs">
                Go to Repairs
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
